module.exports = __webpack_public_path__ + "static/media/aeronave.64fd818a.glb";